import { render, staticRenderFns } from "./TeacherDetail.vue?vue&type=template&id=06fa7e7e&scoped=true"
import script from "./TeacherDetail.vue?vue&type=script&lang=js"
export * from "./TeacherDetail.vue?vue&type=script&lang=js"
import style0 from "./TeacherDetail.vue?vue&type=style&index=0&id=06fa7e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fa7e7e",
  null
  
)

export default component.exports